/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { observer } from 'mobx-react';

import { Button } from 'primitives';
import { DEV_LICENSE_MAX_COLLABORATORS } from 'utils/constants';
import { licenseStore, projectStore } from 'stores';

const AddUserButton = ({ onClick }) => {
  const { collaborators } = projectStore;
  const { isDeveloperLicense } = licenseStore;
  const isDisabled = isDeveloperLicense && collaborators.length >= DEV_LICENSE_MAX_COLLABORATORS;

  return (
    // @ts-expect-error TS2322
    <Button size="small" onClick={onClick} data-test="add-collaborator" disabled={isDisabled}>
      Add user
    </Button>
  );
};

export default observer(AddUserButton);
